export const EmailTemplateHeader = ({ title, description }) => (
    <table
      width="100%"
      cellPadding="0"
      cellSpacing="0"
      style={{ backgroundColor: '#FFFFFF', color: '#000000', textAlign: 'center' }}
    >
      <tr>
        <td style={{ padding: '20px' }}>
          <img
            src="https://submit.opencallforartists.com/wp-content/uploads/2024/10/app-logo.webp"
            alt="Logo"
            style={{ width: '200px' }}
          />
          <h1 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '8px' }}>{title}</h1>
          <p style={{ fontSize: '16px', maxWidth: '600px', margin: '0 auto' }}>
            {description}
          </p>
        </td>
      </tr>
    </table>
  );